import { Config } from "../config";
import { DataService } from "../Services/dataService";
import { FirebaseService } from "../Services/firebaseService";


export class DemarchePage {
    waitingElement: HTMLElement = document.getElementById('waiting') as HTMLElement;
    doneElement: HTMLElement = document.getElementById('done') as HTMLElement;
    loaderElement: HTMLElement = document.getElementById('loader') as HTMLElement;
    downloadElement: HTMLButtonElement = document.getElementById('download') as HTMLButtonElement;

    dataService: DataService;
    firebaseService: FirebaseService;

    constructor() {
        this.firebaseService = new FirebaseService();
        this.dataService = new DataService();
        this.init();
    }

    async init() {
        this.loader(true);
        this.waitingElement.style.display = "none";
        this.doneElement.style.display = "none";
        let token = await this.firebaseService.getUserIdToken()
        let user = await this.dataService.getUser(await this.firebaseService.getUserEmail(), token)

        if (user && user.paymentStatus == "paid" && user.immatData && user.immatData[0]) {
            if (user.immatData[0].certificats && user.immatData[0].certificats.qrcode) {
                this.doneElement.style.display = "block";
                this.downloadElement.addEventListener('click', (event: any) => {
                    event.stopPropagation();
                    event.preventDefault();
                    open("https://getVignettePDF" + Config.functionUrl + "?i=0&t=" + token, '_blank')?.focus();
                })
            }
            else {
                this.waitingElement.style.display = "block";
            }
        }
        this.loader(false)
    }


    loader(show: boolean) {
        this.loaderElement.style.display = show ? 'block' : 'none';
    }
}